<template>
  <svg
    id="Сгруппировать_3144"
    data-name="Сгруппировать 3144"
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
  >
    <g id="Сгруппировать_3143" data-name="Сгруппировать 3143">
      <path
        id="Контур_3586"
        data-name="Контур 3586"
        d="M13.553,0A13.547,13.547,0,0,0,0,13.448,13.637,13.637,0,0,0,13.553,27a13.5,13.5,0,0,0,0-27Z"
        fill="#fedb41"
      />
      <path
        id="Контур_3587"
        data-name="Контур 3587"
        d="M270.448,13.448A13.547,13.547,0,0,1,257,27V0A13.457,13.457,0,0,1,270.448,13.448Z"
        transform="translate(-243.447)"
        fill="#fc3"
      />
      <path
        id="Контур_3588"
        data-name="Контур 3588"
        d="M70.389,60A10.336,10.336,0,1,0,80.672,70.283,10.394,10.394,0,0,0,70.389,60Z"
        transform="translate(-56.836 -56.836)"
        fill="#fea832"
      />
      <path
        id="Контур_3589"
        data-name="Контур 3589"
        d="M267.283,70.283A10.394,10.394,0,0,1,257,80.672V60A10.3,10.3,0,0,1,267.283,70.283Z"
        transform="translate(-243.447 -56.836)"
        fill="#fe9923"
      />
      <text
        id="b"
        transform="translate(9.227 20.605)"
        fill="#fedb41"
        font-size="20"
        font-family="Helvetica"
      >
        <tspan x="0" y="0">b</tspan>
      </text>
      <rect
        id="Прямоугольник_1126"
        data-name="Прямоугольник 1126"
        width="6.72"
        height="2.095"
        rx="1.047"
        transform="translate(8.142 14.942)"
        fill="#fedb41"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconBonus',
  }
</script>
